import { totalCountAtom } from '@components/reviews/atoms';
import { CtaButton } from '@tkww/orion-web-ds-action';
import { TextBody } from '@tkww/orion-web-ds-text';
import { useAtomValue } from 'jotai';
import React, { memo, useRef, type FC } from 'react';
import type VendorAnalytics from '../../../../../../decorators/vendorAnalytics';
import { useTrackReviewImpression } from './hooks/useTrackReviewImpression';
import Styles from './styles.scss';

interface ReviewPromptProps {
	handleClick: () => void;
	vendorAnalytics?: VendorAnalytics;
}

const ReviewPrompt: FC<ReviewPromptProps> = (props) => {
	const { handleClick, vendorAnalytics } = props;
	const hasNoReviewsMessage =
		'No reviews yet! Be the first couple to share your thoughts!';
	const totalVendorReviewsCount = useAtomValue(totalCountAtom);

	const hasNoReviews = !totalVendorReviewsCount;

	const ref = useRef(null);
	useTrackReviewImpression(ref, vendorAnalytics);

	return (
		<div ref={ref}>
			{hasNoReviews && (
				<TextBody size="md" className={Styles.shareThoughts}>
					{hasNoReviewsMessage}
				</TextBody>
			)}
			<CtaButton
				className={hasNoReviews ? Styles.buttonWithFilteringNoReviews : ''}
				styleType="secondary"
				size="md"
				onClick={handleClick}
			>
				Write a review
			</CtaButton>
		</div>
	);
};

export default memo(ReviewPrompt);
